var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.blockTypeComponent)?_c(_vm.blockTypeComponent,{tag:"component",attrs:{"block":_vm.block,"is-preview":_vm.isPreview},on:{"next":function($event){return _vm.$emit('next')},"valid":(val) => _vm.$emit('valid', val)},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }